import { SignInCallback } from '@/containers/signin';
import { useGo } from '@/lib/useGo';

export default function SignInCallbackRoute() {
  const go = useGo();
  return <SignInCallback go={go} />;
}
